import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { FC, useEffect } from 'react';
import { AnimatedBackground } from 'ui/AnimatedBackground';
import { useDispatch, useSelector } from 'react-redux';
import { authInitState, authInitStateInactivity, logoutRequest } from 'redux/reducers/auth/reducer';
import { userInitState } from 'redux/reducers/user/reducer';
import { getAuthRefreshToken } from 'redux/reducers/auth/selectors';

export const ScreensaverInactivityTimeout: FC = () => {
	const dispatch = useDispatch();
	const handleLogInAgain = () => {
		window.location.href = '/';
	};
	const refreshToken = useSelector(getAuthRefreshToken);
	useEffect(() => {
		dispatch(authInitStateInactivity());
		dispatch(authInitState());
		dispatch(userInitState());

		if (refreshToken) dispatch(logoutRequest({ refreshToken }));
	}, [dispatch, refreshToken]);
	return (
		<AnimatedBackground>
			<Dialog
				open
				sx={{
					'& .MuiDialog-paper': {
						backgroundColor: 'transparent',
						boxShadow: 'none',
					},
				}}
			>
				<DialogTitle variant="h4" color="#fff" id="alert-dialog-title">
					You have been inactive for a while, and the session was closed for security reasons
				</DialogTitle>
				<DialogActions disableSpacing sx={{ justifyContent: 'center' }}>
					<Button
						autoFocus
						variant="contained"
						size="large"
						sx={{
							color: '#fff',
							borderRadius: '50px',
							boxShadow: 'none',
							border: '1px solid #fff',
							fontSize: '20px',
							textTransform: 'none',
						}}
						onClick={handleLogInAgain}
					>
						Log in again
					</Button>
				</DialogActions>
			</Dialog>
		</AnimatedBackground>
	);
};
